var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.1667 40.0001H13.8333L7.16666 73.3334H73.8333L67.1667 40.0001ZM61.7 46.6667L63.0333 53.3334H43.8333V46.6667H61.7ZM37.1667 46.6667V53.3334H17.9667L19.3 46.6667H37.1667ZM16.6333 60.0001H37.1667V66.6667H15.3L16.6333 60.0001ZM43.8333 66.6667V60.0001H64.3667L65.7 66.6667H43.8333ZM37.1667 26.6667H43.8333V36.6667H37.1667V26.6667ZM53.0333 24.0334L57.7667 19.3001L64.8333 26.3667L60.1333 31.1001L53.0333 24.0334ZM16.2 26.3667L23.2667 19.3001L27.9667 24.0334L20.9 31.1001L16.2 26.3667ZM10.5 6.66675H20.5V13.3334H10.5V6.66675ZM60.5 6.66675H70.5V13.3334H60.5V6.66675ZM40.5 23.3334C49.7 23.3334 57.1667 15.8667 57.1667 6.66675H50.5C50.5 12.1667 46 16.6667 40.5 16.6667C35 16.6667 30.5 12.1667 30.5 6.66675H23.8333C23.8333 15.8667 31.3 23.3334 40.5 23.3334Z",
    fill: "url(#paint0_linear_18_53)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_53",
    x1: 40.5,
    y1: 6.66675,
    x2: 40.5,
    y2: 73.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB703"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8500"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolar);
export default __webpack_public_path__ + "static/media/solar.9dfec8f81f4fc86ee4754c5b94b494c6.svg";
export { ForwardRef as ReactComponent };